import React from 'react';
import FeedbackModal from './components/FeedbackModal';

function App() {
  return (
      <FeedbackModal />
  );
}

export default App;